export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  thumbnail: string;
  content: string[];
}

export const newsCategories = ["影视新闻", "深度剧评", "专题分析", "行业观察"];

export const newsList: NewsItem[] = [
  {
    id: "n-01",
    title: "《长安阙》收官：一部群像剧如何把“权谋”拍出了人情味",
    date: "2024-10-12",
    category: "深度剧评",
    summary:
      "播出六周，《长安阙》以不俗的口碑完成收官。它没有把镜头全部交给主角，而是让每个配角都有自己的选择与代价，这或许正是它动人的地方。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20an%20ancient%20Chinese%20palace%20corridor%20with%20warm%20lantern%20light%20and%20red%20pillars%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20premium%20magazine%20photography%2C%20high%20detail&width=900&height=560&seq=news-changan-01&orientation=landscape",
    content: [
      "《长安阙》的开场并不惊艳，它甚至刻意收敛了所有戏剧性的锋芒。但随着剧情推进，观众会慢慢发现，这部剧真正的野心不在“反转”，而在“人”。",
      "编剧用了大量笔墨去交代每个角色在权力结构中的位置：谁在保护谁，谁在利用谁，谁又只是想活下去。当观众开始理解每一个人的处境时，所谓的善恶就变得模糊起来。",
      "美术与摄影是另一大惊喜。全剧几乎没有使用饱和度过高的色彩，深红与暗金被反复打磨，构成了一个既华丽又压抑的世界。",
      "如果说有什么遗憾，那大概是后半段节奏略显仓促，几条支线的收束有些匆忙。但这并不影响它成为今年最值得一看的古装剧之一。",
    ],
  },
  {
    id: "n-02",
    title: "十月新剧前瞻：悬疑回暖，都市与年代剧同时发力",
    date: "2024-10-10",
    category: "影视新闻",
    summary:
      "十月共有九部新剧定档，其中悬疑题材占据三席。与此同时，多部都市与现实题材作品也在十月集中上线，市场格局颇为热闹。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20modern%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20premium%20magazine%20photography%2C%20high%20detail&width=900&height=560&seq=news-preview-02&orientation=landscape",
    content: [
      "从目前公布的定档名单来看，十月是一个相当拥挤的档期。九部新剧中，悬疑与犯罪题材共占三席，成为本月最集中的类型。",
      "平台方的排播策略也颇为明显：悬疑剧负责拉动讨论度，都市与现实题材则负责稳住观众的基本盘。",
      "值得注意的是，多部作品的单集时长有所增加，这意味着创作者更倾向于用电影化的叙事节奏来讲述故事。",
    ],
  },
  {
    id: "n-03",
    title: "从《都市浮生》看国产都市剧的“去滤镜化”",
    date: "2024-10-08",
    category: "专题分析",
    summary:
      "当主角不再是完美人设，当办公室不再永远明亮整洁，都市剧反而离观众更近了。《都市浮生》提供了一个值得讨论的样本。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20glass%20office%20building%20facade%20with%20warm%20reflections%20at%20dusk%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20premium%20magazine%20photography%2C%20high%20detail&width=900&height=560&seq=news-chengshi-03&orientation=landscape",
    content: [
      "很长一段时间里，国产都市剧的办公室都亮得像样板间，主角永远光鲜。但近两年，越来越多的作品开始主动卸下这层滤镜。",
      "《都市浮生》的主角会在加班后狼狈地吃一碗泡面，会因为一句无心的话和同事冷战三天。这些细节让角色重新有了重量。",
      "当然，“去滤镜”不等于“卖惨”。真正打动人的，是角色在狼狈之后依然选择往前走的那个瞬间。",
    ],
  },
  {
    id: "n-04",
    title: "《迷雾追凶》的大胆之处：它拒绝给出一个廉价答案",
    date: "2024-10-05",
    category: "深度剧评",
    summary:
      "结局播出后争议不断，但争议本身恰恰说明这部剧的价值——它没有试图让所有人满意，而是坚持了自己的表达。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20rainy%20night%20city%20alley%20with%20reflections%20and%20distant%20street%20lamps%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20premium%20magazine%20photography%2C%20high%20detail&width=900&height=560&seq=news-miwu-04&orientation=landscape",
    content: [
      "《迷雾追凶》的最后一集播出后，社交平台上几乎同时出现了两种截然相反的评价。有人叫好，也有人觉得“被耍了”。",
      "从叙事结构上看，编剧其实一直在暗示答案的开放性。它关心的不是“谁是凶手”，而是“真相究竟能带来什么”。",
      "这种处理方式对观众并不讨好，但它至少诚实：现实中的很多问题，本来就没有一个干净的答案。",
    ],
  },
  {
    id: "n-05",
    title: "科幻剧《星海远征》如何用“慢”制造紧张感",
    date: "2024-10-03",
    category: "专题分析",
    summary:
      "没有密集的爆炸与追逐，这部剧把大量时间交给了等待与沉默。而正是这种漫长，让每一次通讯都变得惊心动魄。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20deep%20space%20nebula%20in%20warm%20red%20and%20gold%20tones%20with%20a%20distant%20spacecraft%20silhouette%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20premium%20magazine%20photography%2C%20high%20detail&width=900&height=560&seq=news-xinghai-05&orientation=landscape",
    content: [
      "在习惯了快节奏剪辑的今天，《星海远征》的克制显得格外特别。它愿意用整整一集去表现一次讯号的等待。",
      "延迟数十光年的设定，让人物的每一次对话都带着无法挽回的时差。观众清楚地知道，他们说的话，对方要很久以后才能听见。",
      "这种设定带来的孤独感，比任何宏大特效都更有冲击力。",
    ],
  },
  {
    id: "n-06",
    title: "行业观察：短剧集为何越来越受创作者青睐",
    date: "2024-09-30",
    category: "行业观察",
    summary:
      "从十六集到十二集，越来越多的剧集开始主动缩短篇幅。这背后既有平台策略的调整，也有创作者对节奏的重新思考。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20film%20production%20set%20with%20warm%20studio%20lights%20and%20camera%20rigs%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20premium%20magazine%20photography%2C%20high%20detail&width=900&height=560&seq=news-industry-06&orientation=landscape",
    content: [
      "如果留意近两年的备案信息，会发现一个明显趋势：剧集的平均集数在下降。",
      "篇幅变短，意味着注水的空间被压缩，也意味着创作者必须更认真地对待每一分钟。对观众来说，这无疑是好事。",
      "当然，短并不等于精。真正决定作品质量的，永远是内容本身，而不是集数数字。",
    ],
  },
];

export function getNewsById(id: string): NewsItem | undefined {
  return newsList.find((n) => n.id === id);
}